var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-card', {
    attrs: {
      "header": "<i class='fa fa-file-o'></i> My Dashboard"
    }
  })], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Informasi!!",
      "hide-footer": ""
    },
    model: {
      value: (_vm.modalInformasi),
      callback: function($$v) {
        _vm.modalInformasi = $$v
      },
      expression: "modalInformasi"
    }
  }, [_c('p', [_vm._v("berdasarkan PER-6/PJ/2024 maka per tanggal 01 Januari 2024 diberlakukan ketentuan NPWP 16 digit. Diharapkan anda dapat mengganti NPWP anda secara mandiri dengan cara sebagai berikut:")]), _vm._v(" "), _c('p', [_vm._v("1. Klik Akun anda di pojok kanan atas halaman web ini")]), _vm._v(" "), _c('p', [_vm._v("2. Klik profile")]), _vm._v(" "), _c('p', [_vm._v("3. Pastikan data yang ditampilkan sesuai")]), _vm._v(" "), _c('p', [_vm._v("4. Klik Ubah NPWP")]), _vm._v(" "), _c('p', [_vm._v("5. Masukkan NPWP 16 digit anda")]), _vm._v(" "), _c('p', [_vm._v("6. Klik Simpan")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": '/profile'
    }
  }, [_vm._v("Ke Profil "), _c('i', {
    staticClass: "fa fa-arrow"
  })])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1cdb34a","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Dashboard.vue
// module id = 159
// module chunks = 0